/**
 * Settlement rail origin URLs — separate from communications (kgnex.com).
 */
const origin = (envKey, fallback) => {
  const value = process.env[envKey];
  if (value && typeof value === 'string') {
    return value.replace(/\/$/, '');
  }
  return fallback;
};

export const ECOSYSTEM_ORIGINS = {
  comms: origin('REACT_APP_MARKETPLACE_ROOT_URL', 'https://kgnex.com'),
  depay: origin('REACT_APP_RAIL_DEPAY_URL', 'https://settle.kgnex.com'),
  /** R4 noticeboard / gig rail — merchant + runner personas */
  gig: origin('REACT_APP_RAIL_GIG_URL', 'https://gig.kgnex.com'),
  utt: origin('REACT_APP_RAIL_UTT_URL', 'https://chain.kgnex.com'),
};

export const railSettleUrl = (rail, tradeIntentId) => {
  if (rail === 'gig') {
    const base = ECOSYSTEM_ORIGINS.gig.replace(/\/$/, '');
    return `${base}/start?tradeIntentId=${encodeURIComponent(tradeIntentId)}`;
  }
  if (rail === 'utt') {
    const base = ECOSYSTEM_ORIGINS.utt.replace(/\/$/, '');
    return `${base}/chain?tradeIntentId=${encodeURIComponent(tradeIntentId)}`;
  }
  const base = ECOSYSTEM_ORIGINS.depay.replace(/\/$/, '');
  return `${base}/?tradeIntentId=${encodeURIComponent(tradeIntentId)}`;
};

export default ECOSYSTEM_ORIGINS;
